import { ApolloClient } from "apollo-client";
import { from as linkFrom, ApolloLink } from "apollo-link";
import { split } from "apollo-link";
import { hasSubscription } from "@jumpn/utils-graphql";
import { createHttpLink } from "apollo-link-http";
import { onError } from "apollo-link-error";
import { InMemoryCache } from "apollo-cache-inmemory";
import some from "lodash/some";

import createAbsintheSocketLink from "./absinthe-socket-link";

const createApolloClient = ({
  onNetworkError,
  onUnauthenticatedError,
  auth,
}) => {
  const errorLink = onError((error) => {
    if (error.networkError && onNetworkError) {
      onNetworkError(error);
    }
    if (
      error.graphQLErrors &&
      onUnauthenticatedError &&
      some(error.graphQLErrors, { message: "unauthenticated" })
    ) {
      onUnauthenticatedError(error);
    }
  });

  const httpLink = createHttpLink({
    uri: "/api/admin/graphql",
    credentials: "same-origin",
  });

  const authLink = new ApolloLink((operation, forward) => {
    operation.setContext(({ headers }) => ({
      headers: {
        ...headers,
        authorization: auth ? `Bearer ${auth}` : undefined,
      },
    }));
    return forward(operation);
  });

  const link = split(
    (operation) => hasSubscription(operation.query),
    createAbsintheSocketLink(auth),
    linkFrom([errorLink, authLink, httpLink])
  );

  const cache = new InMemoryCache();

  // FIXME: defaultOptions do not work as expected currently
  //   see:
  //   - https://github.com/apollographql/apollo-client/issues/3256
  //   - https://github.com/apollographql/apollo-client/issues/2555
  // this works however:
  // const defaultOptions = {
  //   watchQuery: {
  //     fetchPolicy: 'cache-and-network',
  //     errorPolicy: 'ignore',
  //   },
  //   query: {
  //     fetchPolicy: 'network-only',
  //     errorPolicy: 'all',
  //   },
  //   mutate: {
  //     errorPolicy: 'all'
  //   }
  // }
  // const defaultOptions = {query: {fetchPolicy: "network-only"}}
  // const client = new ApolloClient({link, cache, defaultOptions})
  const client = new ApolloClient({ link, cache });

  return client;
};

export { createApolloClient };
